import { useEffect, useRef } from 'react';
import { FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// Validation messages are created with t() when a field is validated, so after a language switch the
// errors already on screen are validated again. It runs after the re-render, when the form's schema
// has the new t(). Fields without an error are left alone, so the user does not see errors early.
export const useRevalidateOnLanguageChange = <T extends FieldValues>({
  formState,
  trigger,
}: Pick<UseFormReturn<T>, 'formState' | 'trigger'>): void => {
  const { i18n } = useTranslation();
  const { language } = i18n;
  const validatedLanguage = useRef(language);
  const { errors } = formState;

  useEffect(() => {
    if (validatedLanguage.current === language) {
      return;
    }
    validatedLanguage.current = language;
    const fieldsWithErrors = Object.keys(errors) as Path<T>[];
    if (fieldsWithErrors.length > 0) {
      void trigger(fieldsWithErrors);
    }
  }, [errors, language, trigger]);
};
